import React, { useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MerchantActions } from '../../../actions';
import axios from "axios";
import { subscriptionKey } from '../../../constants';
import { url } from "../../../constants";
import "./CmsModal.css";

const CmsModal = (props) => {
    const [cmsData, setCmsData] = useState("");
    const [loader, setLoader] = useState(false);
    const [downloadTxt, setDownloadTxt] = useState("");

    const [isChecked, setIsChecked] = useState(false);
    const [isCheckedCheckBox, setIsCheckedCheckBox] = useState(false);
    const [isAllowBuyrToMer, setIsAllowBuyrToMer] = useState(false);

    

    const [scrollPosition, setScrollPosition] = useState(0);
    const modalBodyRef = useRef(null);  


    const getData = () => {
        let pageId = '';
        switch (props.modalTitle) {
            case "Terms & Conditions":
                pageId = 1;
                break;
            case "Disclaimer":
                pageId = 3;
                break;
            case "Privacy Policy":
                pageId = 4;
                break;
            case "Terms & Conditions ":
                pageId = 5;
                break;
            case "Traditional":
                pageId = 6;
                break;
            case "Working Capital":
                pageId = 7;
                break;
            case "E-Commerce":
                pageId = 8;
                break;
            default:
                break;
        }
        props.getCmsPage(pageId).then(() => setLoader(false));
        setDownloadTxt("Download T&C")
        // setCmsData("");
        // if (props.modalTitle == "Terms & Conditions") {
        //     props.getCmsPage(1);
        //     setDownloadTxt("Download T&C")
        // }
        // if (props.modalTitle == "Disclaimer") {
        //     props.getCmsPage(3);
        //     setDownloadTxt("Download Disclaimer")
        // }
        // if (props.modalTitle == "Privacy Policy") {
        //     props.getCmsPage(4);
        //     setDownloadTxt("Download Privacy Policy")
        // }
        // if (props.modalTitle === "Terms & Conditions ") {
        //     props.getCmsPage(5);
        //     setDownloadTxt("Download T&C")
        // }
        // if (props.modalTitle === "Traditional T&C") {
        //     props.getCmsPage(6);
        //     setDownloadTxt("Download T&C")
        // }
        // if (props.modalTitle === "Working Capital T&C") {
        //     props.getCmsPage(7);
        //     setDownloadTxt("Download T&C");
        // }
        // if (props.modalTitle === "E-Commerce") {
        //     props.getCmsPage(8);
        //     setDownloadTxt("Download T&C")
        // }
    }

    // useEffect(() => {
    //     console.log("props.getCmsPageSingle", props.getCmsPageSingle);
    //     setCmsData(props.getCmsPageSingle ? props.getCmsPageSingle.description : "")
    // }, [props.getCmsPageSingle])

    useEffect(() => {

        if (props.openModal) {
            getData()
            setIsAllowBuyrToMer(props.isAllowBuyrToMer);
        } else {
            setLoader(true);
        }
    }, [props.openModal])
    const generatePdf = () => {
        window.print();
    }


    const handleSubmit = async () => {
        console.log('handleSubmit');
        let tokenHeader = "";
        let self = this;
        if (localStorage.getItem("_token")) {
            tokenHeader = localStorage.getItem("_token");
        }
        await axios
        .get(`${url}/common/getGenericSPData/UpdateUserRole?varmerchantid=${localStorage.getItem("_id")}`,
            { headers: {"Ocp-Apim-Subscription-Key":subscriptionKey , "Authorization": tokenHeader } })
        .then((res) => {
            console.log('res-handleSubmit',res);

            if(res.data.success && res.status === 200) {

                axios.get(`${url}/merchant/${localStorage.getItem("_id")}`, { headers: {"Ocp-Apim-Subscription-Key":subscriptionKey, "Authorization": tokenHeader } })
                  .then((res) => {
                          console.log("--res--", res.data);
                        if(res.data.success){
                            let merObject = res.data.body;
                            localStorage.setItem('_roleId',merObject.user.roleId)
                            const redirectPath = '/'
                            window.location = redirectPath;
                        }
                  })
            }    
        })
        .catch(error => {
            console.log('error', error)
        });
    }

    // const handleScroll = (e) => {

    //     console.log('handleScroll',e.target.scrollTop,e.target.scrollHeight);

    //     // const paddingToBottom = 20;
    //     // const bottom =
    //     //   e.target.clientHeight + e.target.scrollTop >=
    //     //   e.target.scrollHeight - paddingToBottom;
    //     // // e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight;
    //     // //console.log("scrollHeight", e.target.scrollHeight);
    //     // //console.log("scrollTop", e.target.scrollTop);
    //     // //console.log("clientHeight", e.target.clientHeight);
    //     // // //console.log("clientHeight", 0.8 * e.target.clientHeight);
    //     // if (bottom) {
    //     //   //console.log("Bottom Reached");
    //     //   this.setState({
    //     //     isDisabled: false,
    //     //     isProceed: true,
    //     //   });
    //     // }
    //   };

    const handleScroll = () => {
        console.log('handleScroll');

        if (modalBodyRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = modalBodyRef.current;

            // Update the scroll position
            setScrollPosition(scrollTop);

            // Check if the user has scrolled to the bottom
            if (scrollTop + clientHeight === scrollHeight) {
                // setReachedBottom(true);
                setIsChecked(true)
                console.log('handleScroll', true);

            } else {
                // setReachedBottom(false);
                setIsChecked(true)
                console.log('handleScroll-else', true);

            }
        }
    };


    useEffect(() => {

        if (modalBodyRef.current) {
            // Attach scroll event listener on mount
            modalBodyRef.current.addEventListener('scroll', handleScroll);

            // Clean up event listener on unmount
            return () => {
                if (modalBodyRef.current) {
                    modalBodyRef.current.removeEventListener('scroll', handleScroll); 
                }
            };
        }
    }, []);

    const handleCheckboxChange = () => {
        console.log('handleCheckboxChange');
        setIsCheckedCheckBox(!isCheckedCheckBox)
    }
    return (
        <div>
            <Modal
                show={props.openModal}
                onHide={() => props.closeModal()}
                className="ModalDemo"
                dialogClassName="mdlDir"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header className="border-0 alignClose" closeButton>{props.modalTitle}
                    <span className="cursor clickevent" style={{marginLeft:'10px'}}onClick={() => generatePdf()}>{downloadTxt}</span>
                </Modal.Header>
                <Modal.Body ref={modalBodyRef}>
                    {
                        loader ?
                            <p>Loading....</p>
                            :
                            <p dangerouslySetInnerHTML={{ __html: props?.getCmsPageSingle?.description ?? "" }} />
                    }
                </Modal.Body>
                {
                    isAllowBuyrToMer ?
                        <Modal.Footer className='justify-content-start'>
                            <div className="customtermcheckbox TncCheckbox py-2 pt-0 pt-0 ms-0">
                                <input type="checkbox" id="checkbox-2-1"
                                    className={"regular-checkbox1 custom-checkbox"}
                                    onChange={handleCheckboxChange}
                                    checked={isCheckedCheckBox}
                                    disabled={!isChecked}
                                    style={{ height: 20, width: 20, borderRadius: 2, }} />

                                <lable className="checkbox_text m-0 ps-2" style={!isChecked ? { color: '#D7D9D8',fontSize:'12px' } : { color: '#373737',fontSize:'12px' }}>
                                    I have read & agree to the Terms & Conditions.
                                </lable>
                            {/* <span className={this.state.isProceed ? "text-success fw-normal" : "text-danger fw-normal"}> ( Read full T&C to proceed ) </span> */}
                            </div>
                            {console.log('isCheckedCheckBox',isCheckedCheckBox)}
                            <button
                                className="CreateAccformLogin w-100 cursor createReqBtn text-center createRdash float-end "
                                type="submit"
                                disabled={isCheckedCheckBox ? false : true}
                                onClick={()=>{handleSubmit()}}
                                style={isCheckedCheckBox ? { backgroundColor: "var(--bg-theme)",marginLeft:"0" } : { backgroundColor: "#cacece",border:'none',marginLeft:"0" }}
                            >
                                Continue
                            </button>
                        </Modal.Footer>
                        : <></>
                }
            </Modal>
            {/* Dont remove this used for generating pdf file for print browser */}
            <p style={{ display: "none" }} id="section-to-print" dangerouslySetInnerHTML={{ __html: props?.getCmsPageSingle?.description ?? "" }} />
        </div>
    )
}

const mapStateToProps = ({ MerchantListReducer }) => {

    return {
        getCmsPageSingle: MerchantListReducer.cmsPageSingle,
    }
}


const mapDispatchToProps = {
    getCmsPage: MerchantActions.getCmsPage,
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsModal);